/**
 * Coupons popup (homepage only)
 * Extracted from `assets/vue-register.js` so register/login no longer contain coupons-pop logic.
 */
(() => {
  function couponsPop() {
    // Vue is loaded globally via `layout/theme.liquid` (vue.min.js)
    // Guard in case Vue isn't ready yet for some reason.
    if (typeof window.Vue === "undefined") return;

    new window.Vue({
      el: "#coupons-pop",
      data: () => ({
        couponPopClosed: false, // 弹窗是否为关闭状态
      }),
      watch: {
        couponPopClosed: (newVal) => {
          if (newVal) {
            document.body.classList.remove("overflow-hidden");
          } else {
            document.body.classList.add("overflow-hidden");
          }
        },
      },
      created() {
        this.couponPopClosed = localStorage.getItem("couponPopClosed");
      },
      methods: {
        closePop() {
          this.couponPopClosed = true;
          localStorage.setItem("couponPopClosed", true);
        },
      },
      template: `
        <div style="position: fixed;left:0;top: 0; width: 100%;height: 100vh;background-color:rgba(0,0,0,.6);z-index: 9" @click="closePop()" v-if="!couponPopClosed">
          <div class="cursor-pointer" style="
          width: 500px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
  ">
            <img style="width: 500px;" src="https://assets.gooddiy.com/image/activity/new_coupons.png?v=20250912">
            <div class="cursor-pointer" style="position: absolute;
      top: 135px;
      right: 70px;">
              <svg width="18" height="16" viewBox="0 0 19 19" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" class="icon icon-close">
                <path d="M18 1L1 18" style="stroke: #fff;" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M1 1L18 18" style="stroke: #fff;" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
        </div>
          </div>
      `,
    });
  }

  function init() {
    if (!document.getElementById("coupons-pop")) return;
    // Avoid double-mount if section is rendered twice (e.g., editor preview).
    if (window.__couponsPopMounted) return;
    window.__couponsPopMounted = true;
    window.couponsPop = couponsPop();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

